<template>
  <div class="ProductsConfig d-none" aria-hidden="true" />
</template>

<script>
import { castPropToType } from '@/helpers/cms-support';

export default {
  name: 'ProductsConfig',
  props: {
    dataConfig: {
      type: [Object, String],
      required: true,
    },
  },
  setup() {
    return { castPropToType };
  },
  computed: {
    conf() {
      return this.dataConfig
        ? this.castPropToType(this.dataConfig, 'object')
        : null;
    },
  },
  mounted() {
    this.$store.dispatch('products/setConfig', this.conf);
  },
};
</script>
